(function($) {

    $.wizard = function(element, options) {

        var defaults = {}

        var plugin = this;

        plugin.settings = {}

        var $element = $(element),
             element = element;

        plugin.init = function() {
            
            plugin.settings = $.extend({}, defaults, options);
            
            $element.find(".step-content:not(:first)").hide();
            $element.data('step',1);

        }

        plugin.step = function() {
            
            return $element.data('step');

        }

        plugin.go = function(target) {

        	var current = plugin.step();

        	$element.find(".step-content[data-step='" + current + "']").fadeOut(function() {

	            $element.find(".step-content[data-step='" + target + "']").fadeIn(function() {

	            	$element.data('step',target);

	                $element.parents('.proposal-steps').find(".step-link").removeClass('active');

	                $element.parents('.proposal-steps').find(".step-link[data-step='" + target + "']").addClass('active');

	                if (current > target) {
		                $element.parents('.proposal-steps').find(".step-link").filter(function() {
			                return parseInt($(this).attr("data-step")) > target && parseInt($(this).attr("data-step")) <= current;
			            }).removeClass('success');
	            	}

	                if ($(window).width() <= 576) {

	                    $('html, body').animate({
	                        scrollTop: $element.find(".step-link--mobile[data-step='" + target + "']").offset().top - 60
	                    }, 1000);

	                } else {

	                    $element.find(".proposal-steps__content").stop(true, true).animate({
	                        scrollTop: 0
	                    }, 1000);

	                }

	            });

	        });

        }

        plugin.init();

    }

    $.fn.wizard = function(options) {

        return this.each(function() {
            if (undefined == $(this).data('wizard')) {
                var plugin = new $.wizard(this, options);
                $(this).data('wizard', plugin);
            }
        });

    }

})(jQuery);

function bindValidation($form, $group, target) {

    $group.each(function() {

        if (target != $(this).data('toggle-target-id')) {

            $(this).find('[data-bind-validation]').each(function() {
                var field = $(this).attr('name');
                $form.data('formValidation').enableFieldValidators(field, false);
                $form.formValidation('resetField', $(this));
            });

            $(this).hide();

        } else {

            $(this).find('[data-bind-validation]').each(function() {
                var field = $(this).attr('name');
                $form.data('formValidation').enableFieldValidators(field, true);
                $form.formValidation('resetField', $(this));
            });
            
            $(this).show();

        }

    });

};

$(document).ready(function() {

	$('.search-select').select2();

    $('.mask-plate-number').inputmask("99 ******", {
        jitMasking: true,
        casing: "upper"
    });

    $('.mask-id').inputmask("9999999999[9]", {
        jitMasking: true
    });

    $('.mask-email').inputmask("email");

    $('body').on('change', '[data-change="bubble"]', function() {

        var $target = $('[data-bubble-target-id="' + $(this).data('target') + '"]');
        var state = $(this).children('option:selected').data('state');

        if (state) {
            $target.addClass('bubble--active');
        } else {
            $target.removeClass('bubble--active');
        }

    });

    $('body').on('change', 'input[type=radio][data-change="toggle"]', function() {

        var $form = $(this).parents('form');
        var $group = $('[data-toggle-group-id="' + $(this).data('toggle-group') + '"]');
        var target = $(this).data('toggle-target');

        bindValidation($form, $group, target);

    });

    $('body').on('change', 'select[data-change="toggle"]', function() {

        var $form = $(this).parents('form');
        var $group = $('[data-toggle-group-id="' + $(this).data('toggle-group') + '"]');
        var target = $(this).children('option:selected').data('toggle-target');

        bindValidation($form, $group, target);

    });

});